export const IMAGE_TYPE_ACCEPT = [
  "image/jpeg",
  "image/pjpeg",
  "image/png",
  "audio/mpeg",
];
